const urlParams = new URLSearchParams(window.location.search);
const scrollToParam = urlParams.get('scrollTo');

if (scrollToParam) {
    document.querySelector(`.${scrollToParam}`)?.scrollIntoView();
}